import type { NoteDisplay } from "@/services/shared/note.types";

export type { NoteDisplay };

/** Supported notes host entities. */
export type NotesEntityKind = "job" | "asset" | "record" | "ticket";

/** Default page size for notes list queries / route loaders. */
export const NOTES_PAGE_SIZE = 100;

export interface NotesListQueryArgs {
	organizationId: string;
	start: number;
	count: number;
}

export interface NotesCreateVars {
	organizationId: string;
	entityId: string;
	text: string;
}

export interface NotesUpdateVars {
	organizationId: string;
	entityId: string;
	noteId: string;
	text: string;
}

export interface NotesDeleteVars {
	organizationId: string;
	entityId: string;
	noteId: string;
}

/**
 * Mutation surface the workspace panel needs (unified variable shapes).
 */
export interface NotesMutationApi<TVars> {
	mutateAsync: (vars: TVars) => Promise<unknown>;
	reset: () => void;
	isPending: boolean;
	error: Error | null;
}

/**
 * Entity-specific notes data access.
 *
 * Built by `use*NotesAdapter` hooks so underlying mutation hooks stay
 * rules-of-hooks safe.
 */
export interface NotesAdapter {
	readonly kind: NotesEntityKind;
	readonly entityId: string;
	/** Returns TanStack `queryOptions(...)` for the entity notes list. */
	listQueryOptions: (args: NotesListQueryArgs) => unknown;
	readonly createMutation: NotesMutationApi<NotesCreateVars>;
	readonly updateMutation: NotesMutationApi<NotesUpdateVars>;
	readonly deleteMutation: NotesMutationApi<NotesDeleteVars>;
}
